export default "__VITE_ASSET__DFSmJoQ___"